export default {
  name: 'Globals',
  data() {
    return {
      questionOrder: [5, 19, 16, 17, 18]
    };
  },
  computed: {
    remainingStories() {
      const stories = JSON.parse(window.sessionStorage.getItem('story-loop'));
      if (stories) {
        return stories;
      } else {
        return [];
      }
    }
  },
  methods: {
    getNextRoute() {
      // Your logic here

      let userObject = JSON.parse(window.sessionStorage.getItem('userObject'));

      const currentRoute = this.$route;

      switch (currentRoute.name) {
        case 'story':
          return { name: 'feedback' };
        case 'feedback':
          if (userObject.stories.length === 1) {
            return {
              name: 'question-block',
              params: { id: this.questionOrder[0] }
            };
          }
          if (userObject.stories.length === 2) {
            return {
              name: 'question-block',
              params: { id: this.questionOrder[1] }
            };
          }
          if (userObject.stories.length === 2) {
            const nextStory = this.remainingStories[0];
            return { name: 'story', params: { id: nextStory.id } };
          }
          if (userObject.stories.length === 3) {
            return {
              name: 'question-block',
              params: { id: this.questionOrder[2] }
            };
          }
          if (userObject.stories.length === 4) {
            const nextStory = this.remainingStories[0];
            return { name: 'story', params: { id: nextStory.id } };
          }
          if (userObject.stories.length === 5) {
            return {
              name: 'question-block',
              params: { id: this.questionOrder[3] }
            };
          }
          return {
            name: 'question-block',
            params: { id: this.questionOrder[0] }
          };
        case 'question-block':
          const nextStory = this.remainingStories[0];

          if (currentRoute.params.id == this.questionOrder[3]) {
            return {
              name: 'question-block',
              params: { id: this.questionOrder[4] }
            };
          }
          if (!nextStory) {
            return { name: 'survey-end' };
          }
          return { name: 'story', params: { id: nextStory.id } };
        default:
          return { name: 'start' };
      }
    },
    hasStoriesLeft() {
      const stories = JSON.parse(window.sessionStorage.getItem('story-loop'));
      return stories && stories.length > 0;
    }
  }
};
